<template>
  <el-dialog
    v-model="visible"
    :title="role?.id ? 'Редактирование роли' : 'Создание роли'"
    class="col-6"
    @close="onClose"
  >
    <el-form :model="form" ref="formRef">
      <el-form-item label="Название" prop="name" :rules="[{ required: true, message: 'Введите название' }]">
        <el-input v-model="form.name" />
      </el-form-item>

      <el-form-item
        class="group-block"
        label="Права доступа"
        prop="permissions"
        :rules="[{ required: true, type: 'array', min: 1, message: 'Выберите хотя бы одно право' }]"
      >
        <div class="permission-controls" style="margin-bottom: 10px;">
          <el-button type="primary" link @click="selectAllPermissions">Выбрать все</el-button>
          <el-button type="primary" link @click="clearAllPermissions">Снять все</el-button>
        </div>
        <div class="permission-groups-row">
          <div v-for="(group, groupName) in permissionGroups" :key="groupName" class="permission-group">
            <div class="group-title">{{ groupName }}</div>
            <el-checkbox-group v-model="form.permissions">
              <el-checkbox
                v-for="perm in group"
                :key="perm"
                :label="perm"
              >{{ permissionLabels[perm] || perm }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="visible = false">Отмена</el-button>
      <el-button type="primary" @click="submit">Сохранить</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    role: Object,
    permissionLabels: { type: Object, required: true },
    permissionGroups: { type: Object, required: true }
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      visible: false,
      form: {
        name: '',
        permissions: []
      }
    }
  },
  watch: {
    modelValue(val) {
      this.visible = val
      if (val) this.initForm()
    },
    visible(val) {
      this.$emit('update:modelValue', val)
    },
    role: {
      immediate: true,
      handler() {
        if (this.visible) this.initForm()
      }
    }
  },
  methods: {
    initForm() {
      if (this.role) {
        this.form = {
          id: this.role.id || null,
          name: this.role.name || '',
          permissions: Array.isArray(this.role.permissions) ? [...this.role.permissions] : []
        }
      } else {
        this.form = { name: '', permissions: [] }
      }
    },
    submit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.$emit('submit', { ...this.form })
        this.visible = false
      })
    },
    onClose() {
      this.visible = false
    },
    selectAllPermissions() {
      const all = Object.values(this.permissionGroups).flat()
      this.form.permissions = [...new Set(all)]
    },
    clearAllPermissions() {
      this.form.permissions = []
    }
  }
}
</script>

<style>
.permission-groups-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.permission-group {
  flex: 1 1 300px; /* или фикс ширину, например, 300px */
  min-width: 260px;
  max-width: 340px;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid var(--ui-color-border-light);
  border-radius: 4px;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.group-block {
  .el-form-item__content {
    align-items: flex-start;
  }

  .permission-group .el-checkbox-group {
    display: flex;
    text-align: left;
    flex-direction: column;
  }

  .permission-group:not(:first-child) {
    margin-left: 10px;
  }
}
</style>
<style scoped>
.permission-group {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid var(--ui-color-border-light);
  border-radius: 4px;
}

.group-title {
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--ui-color-brand);
}
</style>
